import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ToastService } from '../toast.service';
import { NgComponentOutlet } from '@angular/common';
import { NgbToast } from '@ng-bootstrap/ng-bootstrap/toast';

@Component({
  selector: 'app-toasts',
  imports: [NgbToast, NgComponentOutlet],
  template: `
    @for (toast of toastService.toasts(); track toast) {
      <ngb-toast
        [class]="toast.classname"
        [autohide]="toast.autohide !== false"
        [delay]="toast.delay || 5000"
        (hidden)="toastService.remove(toast)">
        <div class="d-flex justify-content-between">
          @if (toast.component) {
            <ng-container *ngComponentOutlet="toast.component; inputs: toast.componentInputs" />
          }
          <button type="button" class="btn-close" aria-label="Close" (click)="toastService.remove(toast)"></button>
        </div>
      </ngb-toast>
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  host: { class: 'toast-container position-fixed top-0 end-0 p-3', style: 'z-index: 1200' },
})
export class ToastsContainer {
  readonly toastService = inject(ToastService);
}
